import React, { Fragment } from 'react'

import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const LoadProfile = () => {
    const profileState = useSelector(state => state.profile);

    return (
        <Fragment>
            <Redirect to={profileState.userProfile !== null ? '/' : '/profile/create'} />
        </Fragment>
    );
}

export default LoadProfile;